export default {
    ["IS_LOADING"](state, isLoading) {
        Object.assign(state, { isLoading });
    },
    ["SET_ERROR"](state, error) {
        Object.assign(state, { error });
    },
    ["SET_SUCCESS"](state, success) {
        Object.assign(state, { success });
    },
    ["SET_DATA_ITEM"](state, dataItem) {
        Object.assign(state, { dataItem });
    },
    ["SET_DATE_LIST"](state, dataList) {
        Object.assign(state, { dataList });
    },
};
